import { useEffect, useState } from 'react';
import { useNavigate } from "react-router";
import type { CryptoRate } from "../../../types/ApiTypes";
import { useApi } from "../../hooks/useApi";
import Dashboard from "../../layout/Dashboard";
import { CoinIcon, ListHead, ListRow, NavContainer, NavWrapper, Ticker } from "../../styles/CrypoAssetStyle";
import { Content, Heading } from "../../styles/OverviewStyle";


export default function CryptoAssetManagement() {
   const navigate = useNavigate()
   const { crypto } = useApi()
   const [cryptoRates, setCryptoRates] = useState<CryptoRate[]>([])
   const [loading, setLoading] = useState(true)
   const [enabled, setEnabled] = useState<Record<string, boolean>>({
      BTC: true, ETH: true, USDT: true, USDC: true, SOL: false, MATIC: true, LTC: false, NEB: false
   })

   const toggle = (k: string) => setEnabled(e => ({ ...e, [k]: !e[k] }))

   useEffect(() => {
      const fetchCryptoRates = async () => {
         try {
            const response = await crypto.getCryptoRates()
            if (response.status === 'success' && response.data) {
               setCryptoRates(response.data)
            }
         } catch (error) {
            console.error('Failed to fetch crypto rates:', error)
         } finally {
            setLoading(false)
         }
      }
      fetchCryptoRates()
   }, [crypto])

   return (
      <Dashboard title="Asset Management / Crypto" icon="carbon:financial-assets" active="asset_management">
         <Content>
            <Heading>Asset Management</Heading>
            <NavContainer>
               <NavWrapper children="Crypto" $active />
               <NavWrapper children="Buy Giftcard" onClick={() => navigate('/assets/giftcard/buy')} />
               <NavWrapper children="Sell Giftcard" onClick={() => navigate('/assets/giftcard/sell')} />
            </NavContainer>

            <h2 className="self-stretch justify-center text-neutral-900 text-lg font-semibold mb-3">API integration</h2>

            <ListHead>
               <div>Asset</div>
               <div className="text-right pr-2">Enabled</div>
            </ListHead>

            {loading ? (
               Array.from({ length: 5 }).map((_, i) => <SkeletonRow key={i} />)
            ) : (
               cryptoRates.map((rate) => (
                  <AssetRow
                     key={rate.currency}
                     name={rate.name}
                     ticker={rate.currency}
                     logo={rate.logoUrl}
                     on={enabled[rate.currency] ?? false}
                     onToggle={() => toggle(rate.currency)}
                  />
               ))
            )}
         </Content>
      </Dashboard>
   )
}

export function AssetRow({ name, ticker, logo }: { name: string; ticker: string; logo: string; on: boolean; onToggle: () => void }) {
   return (
      <ListRow>
         <div className="asset">
            <CoinIcon as="img" src={logo} alt={name} $bg="transparent" />
            <span className="text-sm text-[#101018]">{name}</span>
            <Ticker>{ticker}</Ticker>
         </div>
      </ListRow>
   )
}

function SkeletonRow() {
   return (
      <ListRow>
         <div className="asset">
            <div className="w-5 h-5 rounded-full bg-gray-200 animate-pulse" />
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-12 bg-gray-200 rounded-full animate-pulse" />
         </div>
      </ListRow>
   )
}